export function resolveUploadUrl(path?: string | null): string {
  if (!path) return '';
  const base = import.meta.env.VITE_API_BASE_URL ?? '';
  return `${base}${path}`;
}
